export const copyTextToClipboard = (strToCopy) => {
    return new Promise((resolve) => {
        const aux = document.createElement('div');

        aux.setAttribute('contentEditable', true);
        aux.setAttribute('readonly', '');

        // font less 16px cause iphone - auto zoom
        // top  required for IOS to prevent auto scroll to selected area
        Object.assign(aux.style, {
            position: 'fixed',
            top: `${window.scrollY + 30 || 0}px`,
            'font-size': '16px'
        });
        aux.innerText = strToCopy;
        document.body.appendChild(aux);
        window.getSelection().selectAllChildren(aux);
        document.execCommand('copy');
        document.body.removeChild(aux);

        setTimeout(resolve, 0);
    });
}